import React from "react";
import Notification from "./Notification";

/**
 * Reusable component to handle API request status and display appropriate UI
 * @param {boolean} isLoading - Loading state
 * @param {string} error - Error message (if any)
 * @param {object} data - Success data (if any)
 * @param {string} successMessage - Optional custom success message (defaults to data.message)
 * @param {number} duration - Duration in milliseconds before auto-dismiss (default: 2000ms)
 * @param {React.ReactNode} children - Content to display
 * @returns Component with appropriate status UI (error/success notifications)
 */
const StatusHandler = ({
  error,
  data,
  successMessage,
  duration = 4000,
  children,
}) => {
  // Extract success message either from props or data object
  const displaySuccessMessage = successMessage || (data && data.message);

  return (
    <>
      {error && (
        <Notification type="error" message={error} duration={duration} />
      )}
      {data && displaySuccessMessage && (
        <Notification
          type="success"
          message={displaySuccessMessage}
          duration={duration}
        />
      )}
      {children}
    </>
  );
};

export default StatusHandler;
